{
  "title": "Dancing Lights",
  "source": "Player's Handbook",
  "levelAndSchool": "Evocation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (a bit of phosphorus or wychwood, or a glowworm)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You create up to four torch-sized lights within range, making them appear as torches, lanterns, or glowing orbs that hover in the air for the duration. You can also combine the four lights into one glowing vaguely humanoid form of Medium size. Whichever form you choose, each light sheds dim light in a 10-foot radius.",
    "As a bonus action on your turn, you can move the lights up to 60 feet to a new spot within range. A light must be within 20 feet of another light created by this spell, and a light winks out if it exceeds the spell’s range."
  ],
  "spellLists": ["artificer", "bard", "eldritch-knight", "arcane-trickster", "sorcerer", "wizard"]
}
